import { render, staticRenderFns } from "./PaymentCardknox.vue?vue&type=template&id=45ffd4f3&"
import script from "./PaymentCardknox.vue?vue&type=script&lang=js&"
export * from "./PaymentCardknox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports